import { React, useContext, useEffect, useState, useRef } from "react"
import { CommonContext } from "../contexts/CommonContext"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Paper from "@mui/material/Paper"
import { useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import { AuthContext } from "../contexts/AuthContext"
import ComponentLoader from "../components/ComponentLoader"
import { getDeliveryCharge, getImgMap, logAction } from "../services/api"
import CartOffer from "../assets/cart-offer.png"
import Grid from "@mui/material/Unstable_Grid2"
import ProductCard from "../components/ProductCard"
import NavHeader from "../components/NavHeader"
import TextField from "@mui/material/TextField"
import HighlightOffIcon from "@mui/icons-material/HighlightOff"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material"

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import ItemsSummary from "../components/ItemsSummary"
import NaatuIconPoint from "../assets/naatu-point-cart.png"
import Dialog from "@mui/material/Dialog"
import couponModalImg from "../assets/coupon-modal.png"
import { getCoupons, validateCoupon } from "../services/api"
import CartSuggestions from "../components/CartSuggestions"
import FreeDeliveryPromotion from "../components/FreeDeliveryPromotion"
import closeModalImg from "../assets/close-modal.png"
import { useForm } from "react-hook-form"
const styles = {
  cartCont: {
    display: "flex",
    padding: "10px",
    flexDirection: "column",
  },
  shadowBox: {
    background: "none",
    // borderRadius : '13px',
    // boxShadow : '0px 0px 10px 0px #eaeaea',
    // padding: "5px",
    // margin: "10px",
    // width:'100%'
  },
  shadowBoxDesk: {
    // background : 'white',
    // borderRadius : '13px',
    // boxShadow : '0px 0px 10px 0px #eaeaea',
    // boxShadow:'0px 0px 15px rgba(0, 0, 0, 0.15)'
    padding: "5px",
    marginTop: "18px",
    width: "55%",
  },
  cartOfferImg: {
    width: "100%",
    height: "200px",
    marginTop: "10px",
  },
}

function Cart() {
  const navigate = useNavigate()

  const {
    updateCart,
    getCartData,
    clearCart,
    isDesktop,
    cartData,
    getCouponData,
    couponCacheData,
    clearCouponData,
    showLoader,
    hideLoader,
  } = useContext(CommonContext)
  const [openCoupon, setOpenCoupon] = useState(false)
  const [instructions, setInstructions] = useState("")
  const { isUserLoggedIn, getUserId } = useContext(AuthContext)
  // const [cartData, setCartData] = useState({})
  const [loading, setLoading] = useState(true)
  const [deliveryCharge, setDeliveryCharge] = useState(0)
  const naatuPoints = 122
  const [coupons, setCoupons] = useState([])

  const {
    register: registerCoupon,
    handleSubmit: submitCoupon,
    reset: resetCoupon,
    formState: { errors: errorsCoupon },
  } = useForm()
  const { addCouponToCart, showAlert, hideAlert, showSnackbar } =
    useContext(CommonContext)
  useEffect(() => {
    // fetchCartData()
    // getUserCoupons()
    logAction("PAGE_VIEW", "cart")
    fetchDeliveryCharge()
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [])

  const fetchDeliveryCharge = async () => {
    const cartTotal = cartData?.totalAmount || 0
    setDeliveryCharge(await getDeliveryCharge('delivery', null, cartTotal))
  }

  const checkout = async () => {
    if (await isUserLoggedIn()) {
      navigate(`/delivery`, { state: { instructions: instructions } })
    } else {
      navigate("/auth", { state: { navToCart: true } })
    }
  }

  const navToAuth = async () => {
    if (await isUserLoggedIn()) {
      hideAlert()
      showSnackbar("Login successfull, continue to order")
    } else {
      hideAlert()
      navigate("/auth")
    }
  }
  const getCartSkus = () => {
    const aggregateKeys = [
      "totalCount",
      "totalAmount",
      "totalBasePrice",
      "totalExtras",
      "totalDiscount",
      "bogoDiscount",
    ]
    return Object.keys(cartData || {}).filter(
      (k) => !aggregateKeys.includes(k)
    )
  }

  const verifyCoupon = async (couponData) => {
    const code = (couponData.couponCode || "").toUpperCase().trim()
    if (!code) {
      showAlert("Please enter a coupon code")
      return
    }

    if (!(await isUserLoggedIn())) {
      showAlert(
        <>
          Please signup / login to use this coupon
          <Button
            variant="contained"
            sx={{ marginTop: "10px" }}
            onClick={() => navToAuth()}
          >
            Login / Signup
          </Button>
        </>
      )
      return
    }

    showLoader()
    try {
      const mobile = await getUserId()
      const skus = getCartSkus()
      const cartTotal = (cartData?.totalAmount || 0) 

      const response = await validateCoupon(mobile, code, skus, cartTotal)

      const couponCode =
        response.couponCode || response.coupon?.couponCode || code
      const couponValue =
        response.couponValue ?? response.coupon?.couponValue ?? 0

      if (response.freeSku) {
        updateCart(response.freeSku, true)
      }

      await addCouponToCart({ couponCode, couponValue })
      setOpenCoupon(false)
      showAlert("Coupon Applied Successfully")
    } catch (error) {
      setOpenCoupon(false)
      showAlert(
        error?.data?.message ||
          error?.message ||
          "Invalid coupon code. Please enter a valid one"
      )
    } finally {
      hideLoader()
    }
  }

  const getUserCoupons = async () => {
    //TODO
    const params = {
      customerId: "0",
    }
    let resp = await getCoupons(params)
    if (cartData["C090"]) {
      resp.coupons.push({
        couponCode: "HEALTHYEATS",
        couponValue: 200,
        couponTitle: "HEALTHYEATS",
      })
    } else if (cartData["C091"]) {
      resp.coupons.push({
        couponCode: "HEALTHYEGGS",
        couponValue: 150,
        couponTitle: "HEALTHYEGGS",
      })
    }
    setCoupons(resp.coupons)
    setLoading(false)
  }
  const removeCoupon = async () => {
    clearCouponData()
    fetchDeliveryCharge()
  }
  const handleClose = () => {
    setOpenCoupon(false)
  }
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <Box sx={{ padding: "4vw" }}>
        {loading ? (
          <ComponentLoader />
        ) : (
          <Box sx={{ marginTop: "7vh" }}>
            <NavHeader />
            <Box
              sx={{
                fontSize: "25px",
                fontFamily: "Foregen",
                textDecoration: "underline #A4243D",
                color: "#404040",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <span>Your Cart</span>

            </Box>

            {!cartData || Object.keys(cartData).length < 7 ? (
              <Box sx={{ background: "white", padding: "20px", mt: 2 }}>
                No items in your cart
              </Box>
            ) : (
              <Grid container rowSpacing={2} columnSpacing={4}>
                <Grid
                  item
                  style={isDesktop ? styles.shadowBoxDesk : styles.shadowBox}
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                >
                  {/* Product List Container */}
                  <ItemsSummary itemDetails={cartData} />

                 {/* CART SUGGESTIONS */}
               <FreeDeliveryPromotion cartData={cartData} />
               <CartSuggestions cartData={cartData} />
               
                  {isDesktop ? (
                    <Box
                      sx={{
                        fontSize: "20px",
                        fontFamily: "Foregen",
                        mt: 3,
                        ml: 1,
                        color: "#404040",
                      }}
                    >
                      DELIVERY INSTRUCTIONS
                    </Box>
                  ) : null}

                  <Box
                    sx={{
                      padding: "10px",
                      background: "#FFF7E9",
                      borderRadius: "5px",
                      mt: 1,
                    }}
                  >
                    <TextField
                      placeholder="Add Instructions if any (Max 100 characters)"
                      multiline
                      value={instructions}
                      rows={2}
                      inputProps={{
                        maxLength: 100,
                      }}
                      onChange={(event) => {
                        setInstructions(event.target.value)
                      }}
                      fullWidth
                      maxRows={4}
                    />
                  </Box>

                  <Box>

                      <>
                        {couponCacheData && couponCacheData.couponCode ? (
                          <Box sx={{ padding: "5px 15px" }}>
                            <Box
                              sx={{
                              
                                display: "flex",
                                color: "#a4243d",
                                justifyContent: "space-between",
                                alignItems: "center",
                                fontSize: "13px",
                              }}
                            >
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                                onClick={() => removeCoupon()}
                              >
                                Coupon Applied : [ {couponCacheData.couponCode}{" "}
                                ]
                                <HighlightOffIcon
                                  sx={{ fontSize: "15px", marginLeft: "10px" }}
                                />
                              </Box>
                              <Box>
                                {couponCacheData.couponValue ? (
                                  <> ₹ {couponCacheData.couponValue}/- Off </>
                                ) : (
                                  <>Exclusive Offer</>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        ) : (
                          <form onSubmit={submitCoupon(verifyCoupon)}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                margin: "10px",
                              }}
                            >
                              <input
                                type="text"
                                placeholder="Enter coupon code"
                                {...registerCoupon("couponCode", {
                                  required: "Required field",
                                })}
                                error={Boolean(errorsCoupon?.couponCode)}
                                helperText={errorsCoupon?.couponCode?.message}
                                style={{
                                  width: "171px",
                                  height: "21px",
                                  padding: "4px 8px",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  fontSize: "14px",
                                  fontFamily: "Arial, sans-serif",
                                  background: "#FFF7E9",
                                }}
                              />

                              <button
                                style={{
                                  height: "30px",
                                  padding: "0 16px",
                                  background: "#A4243D",
                                  color: "#FFF",
                                  border: "none",
                                  borderRadius: "4px",
                                  fontSize: "14px",
                                  fontFamily: "Arial, sans-serif",
                                  cursor: "pointer",
                                }}
                              >
                                Apply
                              </button>
                            </Box>
                          </form>
                        )}
                      </>
       
                    <Typography
                      sx={{
                        fontWeight: "500",
                        fontSize: "12px",
                        color: "#a4243d",
                        fontFamily: "Roboto",
                        marginLeft: "10px",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        onClick={async () => {
                          setOpenCoupon(true)
                          await getUserCoupons()
                        }}
                      >
                        View Coupons
                      </div>
                      {/* <div>Redeem your Naatu Coins</div> */}
                    </Typography>
                    <Box
                      sx={{
                        background: "#a4243d",
                        fontFamily:"RobotoSlab",
                        borderRadius: "5px",
                        margin:'10px',
                        padding: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          fontFamily: "Roboto",
                          fontSize: "17px",
                          color: "#FFF0D9",
                          fontWeight: "500",
                          fontFamily:"RobotoSlab",
                          lineHeight: "27px",
                        }}
                      >
                        Price Breakup
                      </Box>

                      <Box
                        sx={{
                          paddingTop: "8px",
                          color: "#FFF0D9",
                          fontWeight: "500",
                          fontFamily:"RobotoSlab",
                          lineHeight: "19px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontFamily:"RobotoSlab",
                            fontSize:'13px'
                          }}
                        >
                          <Box>Sub-Total</Box>
                          <Box>
                            ₹
                            {Number(cartData.totalBasePrice)}
                          </Box>
                        </Box>
                      </Box>


                      {couponCacheData && couponCacheData.couponCode ? (
                        <Box
                          sx={{
                            paddingTop: "1px",
                            fontFamily: "Roboto",
                            fontSize: "14px",
                            color: "#FFF7E9",
                            fontWeight: "500",
                            lineHeight: "19px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              fontWeight:'bold'
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "14px",
                                fontSize:'12px',
                              fontFamily:'RobotoSlab'
                              }}
                            >
                              Coupon Discount [ {couponCacheData.couponCode} ]
                            </Box>
                            <Box sx={{ color: "#fff0d9" }}>
                              {couponCacheData.couponValue ? (
                                <>- ₹{couponCacheData.couponValue}</>
                              ) : (
                                <>Exclusive Offer </>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      ) : null}
                      <Box
                        sx={{
                          paddingTop: "1px",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          color: "#FFF0D9",
                          fontWeight: "500",
                          lineHeight: "19px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontSize:'13px',
                              fontFamily:'RobotoSlab'
                          }}
                        >
                          <Box>Extras</Box>
                          <Box>₹ {cartData.totalExtras ? cartData.totalExtras : 0}</Box>
                        </Box>
                      </Box>

                      <Box sx={{ padding: "2px 0px" }}></Box>

                      <Box
                        sx={{
                          borderTop: "1px solid #b1b1b1",
                          display: "flex",
                          paddingTop: "10px",
                          justifyContent: "space-between",
                          alignItems: "center",
                          fontFamily: "Roboto",
                          fontSize: "17px",
                          color: "#FFF0D9",
                          fontWeight: "500",
                          lineHeight: "23px",
                          fontSize:'13px',
                              fontFamily:'RobotoSlab'
                        }}
                      >
                        <Box>Total</Box>
                        <Box sx={{ fontWeight: "bold" }}>
                          ₹{" "}
                          {cartData.totalAmount -
                            (couponCacheData?.couponValue || 0)}
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box sx={{ padding: "8px 0px" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "11px",
                        opacity: "0.8",
                        margin:'0 10px'
                      }}
                    >
                      <Box>
                        *Delivery charges applicable (calculated at checkout)
                      </Box>
                      <Box>{/* ₹{deliveryCharge} */}</Box>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      backgroundColor: "#a4243d",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      position: "relative",
                      padding: "20px",
                      margin:'0px 10px',
                      borderRadius:'5px',
                      marginBottom:'20px'
                    }}
                  >
                    <Button
                      style={{
                        fontFamily:'RobotoSlab',
                        background: "#FFF0D9",
                        fontWeight:'bold'
                      }}
                       variant="outlined"
                      onClick={() => checkout()}
                    >
                      Proceed to Checkout
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            )}
          </Box>
        )}
      </Box>

      <Dialog
        open={openCoupon}
        onClose={handleClose}
        keepMounted
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "transparent",
            top: "5%",
            boxShadow: "none",
            maxWidth: "420px",
            margin: "0 auto",
            maxHeight: "90vh",
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",

            paddingBottom: "20px",
          }}
        >
          <img
            src={closeModalImg}
            alt="Close"
            onClick={handleClose}
            style={{ cursor: "pointer" }}
          />
        </Box>

        <Box
          sx={{
            backgroundColor: "#a4243d",
            backgroundImage: `url('${couponModalImg}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "20px 16px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            maxHeight: "75vh",
            overflow: "hidden",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: "26px",
              fontWeight: "600",
              color: "#FFF0D9",
              textAlign: "center",
              fontFamily: "Foregen",
              textDecoration: "underline",
              marginBottom: "16px",
              flexShrink: 0,
            }}
          >
            Available Coupons
          </Typography>

          <Box
            sx={{
              width: "100%",
              overflowY: "auto",
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(255,240,217,0.5)",
                borderRadius: "3px",
              },
            }}
          >
            {(!coupons?.length || coupons.filter((c) => !c.hideCoupon).length === 0) ? (
              <Typography
                sx={{
                  color: "#FFF0D9",
                  textAlign: "center",
                  padding: "32px 16px",
                  fontSize: "15px",
                }}
              >
                No coupons are available
              </Typography>
            ) : (
              <>
              {coupons
                ?.filter((c) => !c.hideCoupon)
                .map((coupon, index) => {
                  let discountText = "—"
                  if (coupon.discount_type === "percentage") {
                    const pct = coupon.discount ? `${coupon.discount}% off` : ""
                    const max = coupon.maxDiscount ? ` (max ₹${coupon.maxDiscount})` : ""
                    discountText = pct ? `${pct}${max}` : coupon.maxDiscount ? `Up to ₹${coupon.maxDiscount} off` : "Percentage discount"
                  } else if (coupon.discount_type === "free_sku") {
                    discountText = coupon.discount || "Free item"
                  } else if (coupon.couponValue) {
                    discountText = `₹${coupon.couponValue} off`
                  } else if (typeof coupon.discount === "number") {
                    discountText = `₹${coupon.discount} off`
                  } else if (coupon.discount) {
                    discountText = String(coupon.discount)
                  } else if (coupon.couponTitle) {
                    discountText = coupon.couponTitle
                  }
                  const minOrder = coupon.minimumPurchaseAmount

                  return (
                    <Box
                      key={index}
                      sx={{
                        backgroundColor: "rgba(255,255,255,0.12)",
                        borderRadius: "10px",
                        padding: "14px 16px",
                        marginBottom: "12px",
                        border: "1px dashed rgba(255,240,217,0.6)",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "12px",
                        }}
                      >
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography
                            sx={{
                              fontSize: "18px",
                              fontWeight: "700",
                              color: "#FFF0D9",
                              fontFamily: "Foregen",
                              letterSpacing: "0.5px",
                              marginBottom: "4px",
                            }}
                          >
                            {coupon.couponCode}
                          </Typography>
                          {coupon.couponTitle &&
                            coupon.couponTitle !== coupon.couponCode && (
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  color: "rgba(255,240,217,0.9)",
                                  marginBottom: "6px",
                                }}
                              >
                                {coupon.couponTitle}
                              </Typography>
                            )}
                          <Typography
                            sx={{
                              fontSize: "15px",
                              fontWeight: "600",
                              color: "#FFF0D9",
                              marginBottom: minOrder ? "4px" : 0,
                            }}
                          >
                            {discountText}
                          </Typography>
                          {minOrder && (
                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "rgba(255,240,217,0.8)",
                                marginTop: "2px",
                              }}
                            >
                              {("Minimum order Rs. " + minOrder)}
                            </Typography>
                          )}
                        </Box>
                        <Button
                          variant="contained"
                          onClick={() =>
                            verifyCoupon({ couponCode: coupon.couponCode })
                          }
                          sx={{
                            backgroundColor: "#FFF8E7",
                            color: "#a4243d",
                            fontWeight: "600",
                            fontSize: "13px",
                            textTransform: "none",
                            borderRadius: "8px",
                            padding: "8px 16px",
                            flexShrink: 0,
                            "&:hover": {
                              backgroundColor: "#FFF0D9",
                            },
                          }}
                        >
                          Apply
                        </Button>
                      </Box>
                    </Box>
                  )
                })}
              </>
            )}
          </Box>
        </Box>
      </Dialog>
    </motion.div>
  )
}

export default Cart
